/**
 * AURELIA — component-accordion.js
 *
 * Native <details>/<summary> already provide the semantics, keyboard support
 * and no-JavaScript behaviour. This file adds only the height transition,
 * which <details> cannot do on its own, and optional single-open behaviour
 * for FAQ groups.
 *
 * Because the markup is native, everything still works if this file fails to
 * load — the panel simply opens instantly.
 */
(function () {
  'use strict';

  const { motion } = window.Aurelia;

  const DURATION = 260;

  function animate(details) {
    const body = details.querySelector('.accordion__body, .faq__body');
    if (!body || motion.reduced) return;

    // An in-flight animation must be cancelled, or rapid clicking leaves the
    // panel stuck at an intermediate height.
    if (details.animation) details.animation.cancel();

    if (details.open) {
      const height = body.scrollHeight;
      details.animation = body.animate(
        [
          { height: '0px', opacity: 0 },
          { height: `${height}px`, opacity: 1 },
        ],
        { duration: DURATION, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
    } else {
      // Closing has to be intercepted: the browser removes the content the
      // instant `open` is unset, so there is nothing left to animate.
      const height = body.scrollHeight;
      details.open = true;
      details.animation = body.animate(
        [
          { height: `${height}px`, opacity: 1 },
          { height: '0px', opacity: 0 },
        ],
        { duration: DURATION, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      details.animation.onfinish = () => {
        details.open = false;
        details.animation = null;
      };
    }
  }

  function bind(root) {
    (root || document).querySelectorAll('details.accordion, details.faq__item').forEach((details) => {
      if (details.dataset.accordionReady) return;
      details.dataset.accordionReady = 'true';

      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        if (motion.reduced) return;

        event.preventDefault();

        const group = details.closest('[data-accordion-single]');
        if (group && !details.open) {
          // Single-open groups: close the sibling before opening this one.
          group.querySelectorAll('details[open]').forEach((open) => {
            if (open === details) return;
            open.open = false;
          });
        }

        if (details.open) {
          animate(details);
        } else {
          details.open = true;
          animate(details);
        }
      });
    });
  }

  bind();

  if (window.Aurelia) {
    window.Aurelia.on('section:load', ({ target }) => bind(target));
    window.Aurelia.on('content:appended', ({ target }) => bind(target));
  }
})();
